<script setup lang="ts">
import IconWarning from '@/components/icons/IconWarning.vue'
import UtilLayoutMedia from '@/components/util/UtilLayoutMedia.vue'

const globalNotification = import.meta.env.VITE_GLOBAL_NOTIFICATION ?? ''
</script>

<template>
  <UtilLayoutMedia
    is="aside"
    v-if="globalNotification.length > 0"
    valign="center"
    spacing="natural"
    class="global-notificaiton"
  >
    <template #media-item>
      <IconWarning />
    </template>
    <template #media-content>{{ globalNotification }}</template>
  </UtilLayoutMedia>
</template>

<style lang="scss" scoped>
.global-notificaiton {
  background-color: var(--grey800);
  color: var(--white);
  border-radius: var(--border-radius-8);
  margin: 0 1rem 1rem;
  padding: 1rem 1.5rem;
}
</style>
